module.exports = __webpack_public_path__ + "img/leader_ns.08873796.svg";